import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './Contact.css';

const Contact = () => {
  const { tr } = useLanguage();
  const c = tr.contact;

  const links = [
    {
      label: c.email,
      cta: c.emailCta,
      href: 'mailto:joaocarvalhop7@gmail.com',
      icon: './assets/icons8-email-48.png',
      alt: 'Email',
    },
    {
      label: c.linkedin,
      cta: c.linkedinCta,
      href: 'https://www.linkedin.com/in/joaocarvalhop',
      icon: './assets/icons8-linkedin-48.png',
      alt: 'LinkedIn',
      external: true,
    },
    {
      label: c.whatsapp,
      cta: c.whatsappCta,
      href: 'https://wa.me/5511977685355?text=Ol%C3%A1%20Jo%C3%A3o%2C%20estou%20entrando%20em%20contato%20atrav%C3%A9s%20do%20seu%20portf%C3%B3lio!',
      icon: './assets/icons8-whatsapp-48.png',
      alt: 'WhatsApp',
      external: true,
    },
  ];

  return (
    <section id="contato" className="contact">
      <div className="contact-header">
        <p className="section-title">{c.title}</p>
        <p className="contact-subtitle">{c.subtitle}</p>
      </div>
      <div className="contact-links">
        {links.map(link => (
          <a
            key={link.label}
            className="contact-card"
            href={link.href}
            target={link.external ? '_blank' : undefined}
            rel={link.external ? 'noopener noreferrer' : undefined}
          >
            <img src={link.icon} alt={link.alt} />
            <span className="contact-card-label">{link.label}</span>
            <span className="contact-card-cta">{link.cta}</span>
          </a>
        ))}
      </div>
    </section>
  );
};

export default Contact;
